import { Radio, Contact, Tag, Repeat, CircleDollarSign } from "lucide-react";

// Produto "só Status": a mesma instalação, vendida só para publicar e agendar
// status do WhatsApp. Quem decide o que a empresa usa é o plano
// (`statusOnly`, barrado no `checkAccess` do backend); o endereço status.*
// só troca a vitrine do login e do cadastro.

export const ehSiteDeStatus = () =>
	/^status[.-]/i.test(window.location.hostname);

// O menu inteiro de quem tem o plano, e também as telas que ele pode abrir.
// Etiquetas entram porque o público do status é escolhido por elas.
export const ITENS_DO_PLANO_STATUS = [
	{ to: "/status-posts", icon: Radio, label: "Status" },
	{ to: "/contacts", icon: Contact, label: "Contatos" },
	{ to: "/tags", icon: Tag, label: "Etiquetas" },
	{ to: "/connections", icon: Repeat, label: "Conexões" },
	{ to: "/financeiro", icon: CircleDollarSign, label: "Financeiro" },
];

// Mesma vitrine no login e no cadastro de status.*: o que se diz a quem ainda
// não comprou.
export const VITRINE_STATUS = {
	titulo: "Seus status no ar.",
	destaque: "Sem precisar lembrar de postar.",
	texto:
		"Monte a semana de status do seu WhatsApp de uma vez: foto, vídeo ou texto, no dia e na hora certos, repetindo quando você quiser.",
	beneficios: [
		{
			titulo: "Agende e esqueça",
			detalhe:
				"Escolha data e hora, ou repita toda semana nos dias que você marcar.",
		},
		{
			titulo: "Para quem você escolher",
			detalhe:
				"Publique para todos os contatos ou só para quem tem certas etiquetas.",
		},
		{
			titulo: "Saiba quem viu",
			detalhe: "Veja quem visualizou cada status e quem respondeu.",
		},
	],
};

// O plano de status é vendido pela quantidade de status por mês (0 = sem
// limite, como os outros limites do plano).
export const cotaDoPlano = (plano) =>
	Number(plano?.statusPerMonth) > 0
		? `${plano.statusPerMonth} status por mês`
		: "Status ilimitados";

// Mesma regra para usuários e conexões: 0 no plano é "sem limite", não zero.
export const limiteDoPlano = (quantidade, rotulo, ilimitado) =>
	Number(quantidade) > 0 ? `${quantidade} ${rotulo}` : ilimitado;

export const telaDoPlanoStatus = (caminho) =>
	ITENS_DO_PLANO_STATUS.some(
		({ to }) => caminho === to || caminho.startsWith(`${to}/`)
	);
